import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { AnimatedLogo } from '../../../../../ui';

export type LoadingSpinnerProps = {
  label?: string;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  label = 'Loading...',
}) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.paper',
        zIndex: 50,
      }}
    >
      <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <AnimatedLogo />
        <CircularProgress
          size={96}
          thickness={2}
          sx={{
            position: 'absolute',
            color: 'primary.main',
            opacity: 0.25,
          }}
        />
      </Box>
      <Typography
        variant="body2"
        fontWeight={500}
        color="text.secondary"
        sx={{ mt: 2 }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
